// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SubscribeController from "./subscribe_controller"
application.register("subscribe", SubscribeController)


import LikeController from "./like_controller"
application.register("like", LikeController)

import editFormController from "./editForm_controller"
application.register("editForm", editFormController)


import removeLinksController from "./removeLinks_controller"
application.register("removeLinks", removeLinksController)

import projectMainController from "./projectMain_controller"
application.register("projectMain", projectMainController)

import imgBuildController from "./imgBuild_controller"
application.register("imgBuild", imgBuildController)


import subCommentsController from "./subComments_controller"
application.register("subComments", subCommentsController)

import Comments_controller from "./comments_controller"
application.register("comments", Comments_controller)

import subCommentsNewsController from "./subCommentsNews_controller"
application.register("subCommentsNews", subCommentsNewsController)

import Clipboard_controller from "./clipboard_controller"
application.register("clipboard", Clipboard_controller)

import reply_controller from "./reply_controller"
application.register("reply", reply_controller)
